


















































































































import Vue from "vue";

// Vue components
import DeviceTree from "@/components/DeviceTree/index.vue";

// Model
import { SemesterEnum, getSemesterEnumLabel } from "@/model/data/fitnessStatistics/SemesterEnum";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import {
    GetFitnessStatisticsYearsDistinctCommand,
    GetFitnessStatisticsYearsDistinctResData,
} from "@/model/communication/fitnessStatistics/GetFitnessStatisticsYearsDistinctCommand";
import { GetBranchesCommand } from "@/model/communication/branch/GetBranchesCommand";
import { GetBranchesResData } from "@/model/communication/branch/GetBranchesResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { Branch } from "@/model/data/Branch";
import { GetBranchesReqData } from "@/model/communication/branch/GetBranchesReqData";

export default Vue.extend({
    components: {
        DeviceTree,
    },
    data() {
        return {
            loadingFilterAvailableItems: false,
            selectedSearchMode: 1,
            availableYears: [],
            availableBranches: [],
            selectedYear: null,
            selectedSemester: null,
            selectedBranchId: null,
            deviceTreeSelectedObjectItems: [],
            selectedInstallationNames: null,
            ignoreSelectedInstallationNames: false,
            rerender: 0,
        };
    },
    props: ["loading"],
    computed: {
        availableSemesters() {
            let semesters = Object.keys(SemesterEnum)
                .filter((item) => isNaN(Number(item)))
                .map((c) => this.$t(getSemesterEnumLabel(SemesterEnum[c])));
            return semesters;
        },

        availableBranchesItems() {
            let res = [];
            this.availableBranches.forEach((branch: Branch) => {
                res.push({ text: branch.gln ? branch.name + " - " + branch.gln : branch.name, value: branch.id });
            });

            return res;
        },

        canSubmit() {
            return this.selectedYear != null && this.selectedSemester != null;
        },
    },
    watch: {
        deviceTreeSelectedObjectItems(newValue) {
            this.selectedInstallationNames = null;
            if (newValue) {
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0) {
                    this.ignoreSelectedInstallationNames = true;
                    this.selectedInstallationNames = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                }
            }
        },

        selectedInstallationNames(newValue) {
            if (!this.ignoreSelectedInstallationNames) {
                if (newValue && this.deviceTreeSelectedObjectItems != null) {
                    this.rerender += 1;
                    this.deviceTreeSelectedObjectItems = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device && newValue.indexOf(c.id) >= 0);
                }
            } else this.ignoreSelectedInstallationNames = false;
        },

        selectedSearchMode() {
            this.selectedBranchId = null;
            this.selectedInstallationNames = null;
        },
    },
    methods: {
        onSubmit() {
            let request = { year: null, semester: null, branchId: null, installationNames: null };
            request.year = this.selectedYear;
            request.semester = this.availableSemesters.indexOf(this.selectedSemester);
            request.branchId = this.selectedBranchId ? this.selectedBranchId.value : "";
            request.installationNames = this.selectedInstallationNames;
            this.$emit("send-request", request);
        },
    },
    async mounted() {
        this.loadingFilterAvailableItems = true;

        // recupero gli availableYears con una distinct sul db
        try {
            let res: GetFitnessStatisticsYearsDistinctResData = await new GetFitnessStatisticsYearsDistinctCommand().execute();

            if (res.responseStatus == ApiResponseStatusEnum.Success) this.availableYears = res.availableYears;
            else console.error("cannot fetch available years for filters");
        } catch (e) {
            console.error("cannot fetch available years for filters");
        }

        // recupero gli availableGLNs con una distinct sul db
        try {
            let resp: GetBranchesResData = await new GetBranchesCommand(new GetBranchesReqData(true, false)).execute();

            if (resp.responseStatus == ApiResponseStatusEnum.Success) this.availableBranches = resp.availableBranches;
            else console.error("cannot fetch available branches for filters");
        } catch (e) {
            console.error("cannot fetch available branches for filters");
        }

        // preseleziono alcuni valori di default
        if (this.availableYears.length > 0) this.selectedYear = this.availableYears[0];
        if (this.availableSemesters.length > 0) this.selectedSemester = this.availableSemesters[0];

        this.loadingFilterAvailableItems = false;
    },
});
